/* app/js/src/components/user-branding/user-branding-edit/user-branding-edit.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  width: 100%;
  height: 100%;
  display: block;
  background-color: white;
}
:host .container .back-item {
  text-align: left;
  color: #232f3a;
  font-size: x-large;
}
:host .container .back-item a {
  color: #232f3a !important;
}
:host .container h2 {
  text-align: left;
  padding: 0.5vw;
  flex-grow: 1;
}
:host .container .header .actions {
  padding: 0.5vw;
}
:host .container .header .actions ichannel-button {
  margin-left: 0.5vw;
}
:host .container .edit-table {
  width: 97%;
  margin: 0 auto;
  text-align: center;
  color: #232f3a;
}
:host .container .edit-table tr {
  cursor: pointer;
}
:host .container .edit-table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
:host .container .edit-table tbody tr:hover {
  background-color: #e7dfdf;
}
:host .container .edit-table th {
  border-bottom: 1px solid #232f3a;
}
:host .container .edit-table th,
:host .container .edit-table td {
  height: 2vw;
  text-align: left;
  padding-left: 1vw;
}
:host .container .edit-table th.row-head,
:host .container .edit-table td.row-head {
  text-align: left;
  width: 10vw;
}
:host .container .edit-table th > span.Low,
:host .container .edit-table td > span.Low {
  color: #4472c1;
}
:host .container .edit-table th > span.Medium,
:host .container .edit-table td > span.Medium {
  color: #f5d7ac;
}
:host .container .edit-table th > span.High,
:host .container .edit-table td > span.High {
  color: #c49c9e;
}
:host .container .edit-table th > a,
:host .container .edit-table td > a {
  color: #40c4ff;
  text-decoration: none;
}
:host .container .edit-table th > a:hover,
:host .container .edit-table td > a:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=user-branding-edit.component.css.map */
